angular.module('tgaAdmin').controller('CustomFieldModalController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$uibModalStack',
  'customFieldService',
  'extras',
  '$translate',
  function ($scope, $state, $window, $uibModalInstance, $uibModalStack, customFieldService, extras, $translate) {
    $scope.data = {
      alerts: [],
      closeButton: extras.closeButton,
      customFieldOptions: {
        types: [
          {
            id: 'text',
            name: 'Text Input',
          },
          {
            id: 'dropdown',
            name: 'Dropdown',
          },
        ],
        condition: [
          {
            id: 'optional',
            name: 'Optional',
          },
          {
            id: 'required',
            name: 'Required',
          },
          {
            id: 'disabled',
            name: 'Disabled',
          },
        ],
      },
      existingCustomFields: [],
      choose: false,
      is_external: extras.is_external,
    };

    $scope.viewmodel = {
      name: null,
      type: null,
      options: [],
      condition: null,
      selectedCustomFieldOption: null,
      existingField: null,
    };

    $scope.initialize = function () {
      if (extras.type) {
        $scope.data.customFieldOptions.types = $scope.data.customFieldOptions.types.filter(
          (field) => field.id === extras.type,
        );
      }

      customFieldService
        .getCustomFields({ type: extras.type })
        .then((customFields) => {
          $scope.data.existingCustomFields = customFields;
        })
        .catch((error) => {
          $scope.actions.createAlert(error);
        });
    };

    $scope.actions = {
      submit(form) {
        form.submitted = true;

        $scope.data.alerts = [];

        if (form.$invalid) {
          $scope.actions.createAlert(
            `<span class="fa fa-exclamation-triangle"></span> ${$translate
              .instant('common.check_form_for_errors')
              .toString()}`,
            'danger',
          );
          return;
        }

        $uibModalStack.getTop().value.backdrop = 'static';
        $uibModalStack.getTop().value.keyboard = false;
        $scope.data.closeButton = false;

        $scope.processing = true;
        let data = {};

        if ($scope.data.choose === true) {
          data = $scope.viewmodel.existingField;
          $uibModalInstance.close($scope.viewmodel.existingField);
        } else {
          data = $scope.viewmodel;
          customFieldService.addCustomField(data).then(
            (customField) => {
              $uibModalInstance.close(customField);
            },
            (error) => {
              $scope.actions.createAlert(
                `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${error.message}`,
                'danger',
              );
              $scope.processing = false;
            },
          );
        }
      },
      addCustomFieldOption() {
        $scope.viewmodel.options.push({ name: null });
      },
      changeCustomFieldType() {
        if ($scope.viewmodel.type === 'text') {
          $scope.viewmodel.options = [];
        } else {
          $scope.actions.addCustomFieldOption();
        }
      },
      changeChoice() {
        $scope.viewmodel = {
          name: null,
          type: null,
          options: [],
          condition: null,
          selectedCustomFieldOption: null,
        };

        $scope.customFieldForm.submitted = false;
      },
      createAlert(msg, type) {
        $scope.data.alerts = [];
        $scope.data.alerts.push({
          msg,
          type,
        });
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };
    $scope.initialize();
  },
]);
